import _http_v1 from "../../../../../../http_requests/_http_v1"
import rangepicker_locales from "../../../../../../locale/rangepicker"

//OBJETO PARA GERAR E CONTROLAR O FORMULÁRIO DE OPÇÕES DE CONSULTA
//OUTROS OBJETOS NA APLICAÇÃO (EX:CHART) TEM TOTAL INTERESSE NA VARIAVEL 'CURRENT_OPTIONS' DESSE FORMULÁRIO
//ENTÃO, SEMPRE QUE UMA ALTERAÇÃO FOR FEITA, É IMPORTANTE QUE ESSA VARIAVEL RETRATE O ESTADO ATUAL DO FORMULARIO
//EM REACT SERIA EASY COM STATE :) (OU PROXY, MAS N FIZ ASSIM :( )
export default function Form(options){
    let container = options.container
    let period_element,transmission_type_element,main_container_element, date_element, date_input,submit_element,group_type_element
    let current_options = {
        start_date: moment().format("YYYY-MM-DD") + " 03:00", //dia atual
        end_date: moment().add(1, 'day').format("YYYY-MM-DD") + " 02:59",
        group_type: "minute",
        transmission_type_ids: []
    }

    this.generate = () =>{
        //gerando elementos
        generateMainContainer()
        generateSubmitInput()
        generateDateInput()
        
        period_element = generateSelect({list_options:[],class_list: "form-control", label:"Tipo de transmissão"})
        transmission_type_element = generateSelect({list_options:[],class_list: "form-control", label:"Tipo de transmissão", attributes:[['multiple',true],["title", "Selecione o tipo de transmissão"]]})
        group_type_element = generateSelect({list_options:[{id: 'minute', name:'Coleta'},{id: 'hour', name:'Hora'},{id: 'day', name:'Dia'},{id: 'month', name: 'Mês'}],class_list: "form-control", label:"Agrupar por:", value_field: 'id', text_field: 'name'})

        //appendando elements
        // main_container_element.append(submit_element)
        main_container_element.append(date_element)
        main_container_element.append(transmission_type_element)
        main_container_element.append(group_type_element)

        //inserindo no container geral
        $(container).html(main_container_element)

        fillTransmissionType()

        eventsHandler()
    }

    this.getCurrentOptions = () =>{
        return current_options
    }

    //DININE A DATA INICIAL E A DATA FINAL DO RANGEPICKER, E OS VALORES DAS VARIAVEIS DA CURRENT_OPTIONS
    this.setDate = (start_date, end_date) =>{
        if(start_date, end_date){
            //setando a data de inicio do rangepicker
            $(date_input).data('daterangepicker').setStartDate(start_date);

            //setando a data fim do rangepicker
            $(date_input).data('daterangepicker').setEndDate(end_date);

            //rangepicker já alterado, agora disparando evento para alterar também as variaveis do 'current_options'
            $(date_input).trigger('changed', {start: moment(start_date, "DD-MM-YYYY"), end: moment(end_date, "DD-MM-YYYY")})
        }
    }

    function eventsHandler(){
        $(transmission_type_element).find('select').on('change', function(){
            current_options.transmission_type_ids = $(this).val()
        })
        $(group_type_element).find('select').on('change', function(){
            current_options.group_type = this.value
        })
        //LISTENER PARA MUDAR O VALOR DA CURRENT_OPTIONS DE ACORDO COM OS PARAMETROS
        $(date_input).on('changed', (e,data)=>{
            current_options.start_date = data.start.format("YYYY-MM-DD") + ' 03:00'
            current_options.end_date = data.end.add(1, 'day').format("YYYY-MM-DD") + ' 02:59'
        })
    }

    function generateSubmitInput(){
        let container = document.createElement('div')
        container.classList.add('mb-3')
        let element = document.createElement('button')
        container.appendChild(element)
        element.classList.add('offcanvas_options_submit')
        element.textContent="Buscar"
        submit_element = container
    }

    function generateDateInput(){
        let element = document.createElement('div')
        element.classList.add('form-group')
        let input = document.createElement('input')
        let label = document.createElement('label')
        element.appendChild(label)
        element.appendChild(input)
        
        label.textContent = "Período de Dados"
        input.type = 'text'
        input.classList.add('form-control')
        $(input).daterangepicker({locale:rangepicker_locales}, function(start, end, label){
            //callback ao modificar data
            //valor da caixa ja foi alterado, disparando evento para alterar as variaveis que devem conter essas datas
            $(date_input).trigger('changed', {start: start, end:end})
        })
        date_element = element
        date_input = input
    }

    function generateSelect(options){
        let group = document.createElement('div')
        group.classList.add('form-group')
        if(options.label){
            $(group).append("<label>"+options.label+"</label>")
        }
        let element = document.createElement('select')
        element.classList.add(options.class_list)

        if(options.attributes){
            options.attributes.forEach(attr=>{
                element.setAttribute(attr[0], attr[1]) 
            })
        }

        options.list_options.forEach(option=>{
            $(element).append("<option value='"+option[options.value_field]+"'>"+option[options.text_field]+"</option>")
        })
        group.append(element)
        return group
    }
    function generateMainContainer() {
        main_container_element = document.createElement('div')
    }

    function fillTransmissionType(){
        _http_v1.get("transmission_types", {}).then(data=>{
            data.forEach(transmission=>{
                $(transmission_type_element).find('select').append("<option value='"+transmission.id+"'>"+transmission.name.toUpperCase()+"</option>")
            })
            $(transmission_type_element).find('select').selectpicker({multiple:true})
        })
    }
}